import Notification, { NotificationType } from './Notification'
import styles from './NotificationContainer.module.css'

type Props = {
  notifications: NotificationType[]
  onClose: (id: string) => void
}

export default function NotificationContainer({ notifications, onClose }: Props) {
  return (
    <div className={styles.container}>
      {notifications.map((notification) => (
        <Notification 
          key={notification.id} 
          notification={notification} 
          onClose={onClose}
        />
      ))}
    </div>
  )
}